export const environment = {
  production: true,
  api: {
    serverUrl: 'https://web-api-demo.better-health-project.eu',
  },
  sentry: {
    enabled: true,
    dsn: 'https://c7bc17ebd89a5f113821a08daa7300cb@o4504695068164096.ingest.us.sentry.io/4508925282811904',
    environment: 'demo',
  },
  auth0: {
    domain: 'demo-nl.eu.auth0.com',
    clientId: 'HW3XU9Jbwx5spFKLsPag6S5f0IYlVRDQ',
    authorizationParams: {
      audience: 'https://better-back-demo.com',
      redirect_uri: 'https://web-demo.better-health-project.eu/callback',
    },
    errorPath: '/callback',
  },
};
